import React, { Component, Fragment } from "react";

import Pagination from "../../Pagination/Pagination";

import "./Favorites.css";

class Favorites extends Component {
    constructor(props) {
        super(props);

        this.get_data = this.get_data.bind(this);
        this.delete = this.delete.bind(this);
    }

    get_data() {}

    componentDidMount() {
        let { connection, toast } = this.props;

        connection
            .get_favorites()
            .then((res) => {
                let { favorites, notifies } = res.data;
                this.setState({ favorites, notifies });
            })
            .catch((err) => {
                toast(
                    "خطا در دریافت اطلاعات",
                    "علاقه مندی ها بارگزاری نشدند",
                    " danger"
                );
            });
    }
    delete(action, id) {
        let { toast, connection } = this.props;
        connection
            .user_action_on_item(action, id, false)
            .then((res) => {
                toast("حذف ", "کالا از لیست حذف شد", " confirm");
                const l = this.state;
                l[action] = res.data[action];

                this.setState(l);
            })
            .catch((err) => {
                toast("حذف ", "کالا از لیست حذف نشد", " danger");
            });
    }
    state = { favorites: [], notifies: [] };
    render() {
        let { favorites, notifies } = this.state;
        return (
            <div className='FavoritesComponent'>
                <div className='FavoritesContainer'>
                    {favorites && favorites.length > 0 && (
                        <div className='container favorites'>
                            <div className='caption'>
                                <i className='ri-heart-fill text primary'></i>
                                علاقه مندی ها
                            </div>
                            {favorites &&
                                favorites.map((f, index) => {
                                    return (
                                        <div className='item favorite text primary'>
                                            <a href={"/item/" + f.id}>
                                                {f.name}
                                            </a>
                                            <i
                                                className='ri-heart-fill'
                                                onClick={(ev) => {
                                                    this.delete(
                                                        "favorites",
                                                        f.id
                                                    );
                                                }}
                                            ></i>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                    {notifies && notifies.length > 0 && (
                        <div className='container notifies'>
                            <div className='caption'>
                                <i className='ri-notification-3-fill text info'></i>
                                اعلان موجودی
                            </div>
                            {notifies &&
                                notifies.map((n, index) => {
                                    return (
                                        <div className='item notify'>
                                            <a href={"/item/" + n.id}>
                                                {n.name}
                                            </a>
                                            <i
                                                className='ri-notification-3-fill text info'
                                                onClick={(ev) => {
                                                    this.delete(
                                                        "notifies",
                                                        n.id
                                                    );
                                                }}
                                            ></i>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                    {(!favorites || favorites.length < 1) &&
                        (!notifies || notifies.length < 1) && (
                            <div className='no_order text danger'>
                                <i className='ri-close-circle-line '></i>
                                هیچ اعلان یا علاقه مندی وجود ندارد.
                            </div>
                        )}
                </div>
            </div>
        );
    }
}

export default Favorites;
